import React, { createContext, PropsWithChildren, useContext, useEffect } from "react";
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

// ==============================|| NAVIGATION - SCROLL TO TOP ||============================== //

type ScrollTopContextType = {
    scrollTop: () => void;
};
const ScrollTopContext = createContext<ScrollTopContextType>({scrollTop: () => {}})

const ScrollTop = ({ children }: PropsWithChildren) => {
    const location = useLocation();
    const { pathname } = location;

    const scrollTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };

    useEffect(scrollTop, [pathname]);

    return (
      <ScrollTopContext.Provider value={{scrollTop}}>
          {children}
      </ScrollTopContext.Provider>
    )
};

ScrollTop.propTypes = {
    children: PropTypes.node,
};

export const useScrollTop = () => {
    return useContext(ScrollTopContext);
};

export default ScrollTop;
